import { Injectable } from '@angular/core';
import Dexie from 'dexie';

class DigitalEyesDb extends Dexie {
  public InspectionFilesDetails: Dexie.Table; // id is number in this case
  public InspectionTaskDetails: Dexie.Table;
  public constructor() {
    super("DigitalEyesDb");
    this.version(1).stores({ 
      InspectionFilesDetails: "++InspectionFileId,ImgFileIdForAudio,TaskID,UserID,zoneDetails,FileType,LocalFileUrl,FileSize,FileName,UploadStatus,RetryHitting,MetaData,ServerFileID,ServerFileName,LiveUrl",
      InspectionTaskDetails: "++Id,TaskID,ServerData,ServerDataKeys,UIBindings,UntaggedImages"
    });
    this.InspectionFilesDetails = this.table("InspectionFilesDetails");
    this.InspectionTaskDetails = this.table("InspectionTaskDetails");
  }
}

@Injectable({
  providedIn: 'root'
})

export class LocalDbService {
  db: any;
  constructor() { }

  async truncateData(){
    this.db = new DigitalEyesDb();
    await this.db.InspectionFilesDetails.clear();
    await this.db.InspectionTaskDetails.clear();
  }

  async addInspectionFilesDetails(obj) {
    this.db = new DigitalEyesDb();

    this.db.transaction('rw', this.db.InspectionFilesDetails, async () => {
      // if ((await this.db.InspectionFilesDetails.where({ TaskID: 'DYSFBTSK14' }).count()) === 0) {
      const id = await this.db.InspectionFilesDetails.add(obj);
      console.log(`Added friend with id ${id}`);
    }).catch(e => {
      alert(e.stack || e);
    });
  }

  assignData(taskDetails){
    let items: any = [];
    taskDetails.forEach(element => {
      items.push({
        InspectionFileId: element.InspectionFileId,
        ImgFileIdForAudio: element.ImgFileIdForAudio,
        TaskID: element.TaskID,
        UserID: element.UserID,
        zoneDetails: element.zoneDetails,
        FileType: element.FileType,
        LocalFileUrl: element.LocalFileUrl,
        FileSize: element.FileSize,
        FileName: element.FileName,
        UploadStatus: element.UploadStatus,
        RetryHitting: element.RetryHitting,
        MetaData: element.MetaData,
        ServerFileID: element.ServerFileID,
        ServerFileName: element.ServerFileName,
        LiveUrl: element.LiveUrl
      });
    });

    return items;
  }

  async getTaskFileDetailsToUpload(TaskID, maxHitCounter) {
    this.db = new DigitalEyesDb();
    const taskDetails = await this.db.InspectionFilesDetails.where("TaskID").equals(TaskID).and(item => item.RetryHitting < maxHitCounter && item.UploadStatus == 'false').toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else{
      alert('Error getTaskFileDetailsToUpload')
    }
  }

  async getsyncUnsyncTaskFileDetails(TaskID, UploadStatus = false){  
    this.db = new DigitalEyesDb();
    
    const taskDetails = await this.db.InspectionFilesDetails.where("TaskID").equals(TaskID).and(item => item.UploadStatus == UploadStatus).toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else{
      alert('Error getsyncUnsyncTaskFileDetails')
    }
  }

  async getUnsyncFilesWithMaxRetry(TaskID, maxHitCounter){
    this.db = new DigitalEyesDb();
    const taskDetails = await this.db.InspectionFilesDetails.where("TaskID").equals(TaskID).and(item => item.RetryHitting >= maxHitCounter && item.UploadStatus == 'false').toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else{
      alert('Error getUnsyncFilesWithMaxRetry')
    }
  }

  async getAllFileDetailsByInspectionFileId(InspectionFileId = null){
    this.db = new DigitalEyesDb();
    const taskDetails = await this.db.InspectionFilesDetails.where("InspectionFileId").equals(InspectionFileId).toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else{
      alert('Error getAllFileDetailsByInspectionFileId')
    }
  }

  async getAllFileDetailsByTaskID(TaskID = null){
    this.db = new DigitalEyesDb();
    const taskDetails = await this.db.InspectionFilesDetails.where("TaskID").equals(TaskID).toArray();
    if (taskDetails.length > 0) {
      return this.assignData(taskDetails);
    }
    else{
      alert('Error getAllFileDetailsByTaskID')
    }
  }

  updateHitCount(InspectionFile, hitCount){
    this.db = new DigitalEyesDb();

     this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, {RetryHitting: hitCount}).then(function (updated) {
      if (updated){
        console.log ("Counter update for File ID: ", InspectionFile.InspectionFileId);
        return updated;
      }
      else
        console.log ("FileID not found. Nothing was updated");
    });
  }

  updateFileDetails(InspectionFile, uploadFileDetails){
    this.db = new DigitalEyesDb();
    var uploadStatus = uploadFileDetails.StatusCode == 200 ? true: false;
    
    this.db.InspectionFilesDetails.update(InspectionFile.InspectionFileId, {UploadStatus: uploadStatus, ServerFileName: uploadFileDetails.Data[0].fileName}).then(function (updated) {
      if (updated){
        console.log ("Counter update for File ID: ", InspectionFile.InspectionFileId);
        return updated;
      }
      else
        console.log ("FileID not found. Nothing was updated");
    });
  }

  async deleteInspectionFiles(InspectionFileId) {
    this.db = new DigitalEyesDb();
    var deleteCount = await this.db.InspectionFilesDetails.where("InspectionFileId").equals(InspectionFileId).delete();
    if(deleteCount){
      return true;
    }
    else{
      return false;

    }
  }

  async deleteInspectionFilesByFileName(FileName) {
    this.db = new DigitalEyesDb();
    var deleteCount = await this.db.InspectionFilesDetails.where("FileName").equals(FileName).delete();
    if(deleteCount){
      return true;
    }
    else{
      return false;
    }
  }

  async deleteTaskFilesFromLocal(TaskID){
    this.db = new DigitalEyesDb();
    var deleteCount = await this.db.InspectionFilesDetails.where("TaskID").equals(TaskID).delete();
    if(deleteCount){
      return true;
    }
    else{
      return false;
    }
  }

  async getAllInspectionFilesDetails() {
    // return await this._localDbService.getAll('InspectionFilesDetails').toPromise();
  }
}
